var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('k-form-design',{style:({ height: '70vh' }),attrs:{"title":_vm.title,"parentJsonData":_vm.jsonData},on:{"save":_vm.handleSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }